import React, { Component } from 'react';
import * as wActs from "../actions/website-actions";
import * as wConst from "../consts/website-consts";
const AppUrl = wConst.ROOT_URL("https://app.swinity.com/api");

/*
  {
    "Id": "string",
    "Channel": "string",
    "Max": 0,
    "Min": 0,
    "MaxStandard": 0,
    "MinAdvertiseHere": 0,
    "MaxAdvertiseHere": 0,
    "CountryCode": "string"
    "Requested": "DATE"
    "Callback": function
  }
 */

class BannersLoader {
  constructor(props) {
    //PROPS: Interval,TriggerMS, ImpressionsMS, Request, UserId
    this.state = {
      Unloaded: [],
      Loaded: [],
      Impressions: [],
      ApiResult: {Code: 500, Message: "New", Result: []}
    };
    this.props = props;
    this.setState = (ste) => {
      this.state = {...this.state, ...ste};
    }
    this.Loop = setInterval(() => {
      //console.log("########################################BANNERS######################################");
      let {Unloaded,Loaded,Impressions} = this.state;
      if(Unloaded.length>0) {
        let last = Unloaded[Unloaded.length - 1];
        let ttLv = new Date().getTime() - new Date(last.Requested);
        if (ttLv > this.props.TriggerMS) {
          let load = Unloaded.map((v) => {
            return v
          });
          Unloaded = [];
          this.setState({Unloaded: Unloaded,Loading: load});
          //console.log(`Gonna Load ${load.length} zones...`, load);
          let adData = load.map((v)=> {return {...v}});
          adData = JSON.stringify(this.compressZones(adData));
          //console.log("LoadingAfterCompressZones",load)
          this.fetchBanners(adData,load);
        }
      }
      if(Impressions.length>0) {
        let lastI = Impressions[Impressions.length - 1];
        let ttLv = new Date().getTime() - new Date(lastI.Requested);
        if (ttLv > this.props.ImpressionsMS) {
          let pobj = {
            Hash: "",Channel: wActs.getParameterByName("channel",window.location.href,""),
            IpAddress: this.props.Request.IpAddress,
            CountryCode: this.props.Request.CountryCode,
            AnonymousId: this.props.Request.AnonymousId,
            UserId: this.props.UserId,
            Ads: Impressions.map((b)=> {return b.Banner})
          };
          this.processImpressions(pobj);
          this.setState({Impressions: []});
        }
      }
    },props.Interval);
  }
  compressZones(load) {
    let zones = [];

    load.map((v)=> {
      let ext = zones.filter((t) =>{return t.Id == v.Id});
      if(ext[0]) {
        ext[0].Max = parseInt(ext[0].Max)+parseInt(v.Max)+"";
        ext[0].Min = parseInt(ext[0].Min)+parseInt(v.Min)+"";
        ext[0].MaxStandard = ext[0].Max;
      } else {
        zones.push(v);
      }
    });

    //console.log("Compressed Zones",zones);
    return zones;
  }
  addZone(dta) {
    let {Unloaded} = this.state;
    dta.Requested = new Date();
    if (!Unloaded.some((t) => {
      return t.DomId == dta.DomId;
    })) {
      Unloaded.push(dta);
      this.state.Unloaded = Unloaded;
    }
  }
  fetchBanners(dta,loading) {
    let headers = {
      "X-Alt-Referer": window.location.href,
      "Content-type": "application/json"
    };
    if(this.state.ApiAnonId) {
      headers["X-Alt-AnonymousId"] = this.state.ApiAnonId;
    }
    fetch(`${AppUrl}/creatives?count=false`, {method: "POST", headers: headers, body: dta})
      .then(resp => resp.json())
      .then((data) => {
          //this.setState({ApiResult: data}); //MAY NOT NEED, DEBUG ONLY...
          this.processBanners(data,loading);
        }
      ).catch((ex)=>{
      //console.log("HTTP Error...",ex)
    });
  }

  processBanners(data,loading) {
    if(data.Code !== 200 || !Array.isArray(data.Result) || data.Result.length<=0) {
      return; //FUCK ME, Error, No Banners.. Do Not Interrupt
    }

    //loading = JSON.parse(loading);
    let loaded = data.Result.map((v,i)=>{
      return {...v, recId: i}; //Id Them For Removal As We Call Events...
    });

    //console.log("Loading:",loading);

    let x = 0; let all = loaded;
    while(loaded.filter((t)=>{return t.Zone ? true : false}).length>0) {
      x++; if(x>200) {
        console.log("Break after 200 interations")
        break;}
      loaded = this.compressLoading(loading,loaded,all);
    }


  }
  shuffle(array) {
    array.sort(() => Math.random() - 0.5);
  }

  compressLoading(loading,loaded,all) {
    //console.log("Loading compress",loading);
    loading.map((zone,zoneIdx)=>{
      let zoneCode = zone.Id;
      //console.log("Loaded",loaded)
      let zoneRes = loaded.filter((t) => {
        if(t.Zone) {
          return t.Zone.Code.toLowerCase() == zoneCode.toLowerCase();
        } else {
          return null;
        }
      });
      if(zoneRes.length<=0) {
        zoneRes = all.filter((t) => {
          if(t.Zone) {
            return t.Zone.Code.toLowerCase() == zoneCode.toLowerCase();
          } else {
            return null;
          }
        });
        this.shuffle(zoneRes);
      }
      if(zoneRes.length>0) {
        if(zoneRes.length>zone.Max) {
          //console.log("Got Dupe Zones...", zone.Max);
          zoneRes = zoneRes.slice(0, zone.Max);
          //console.log("Spliced Zones...", zoneRes);
        }
        if(typeof zone.Callback == "function") {
          zone.Callback(zoneRes); //Call Event
        } else {
          //console.error("Callback/Props FAILED!!!", zone);
        }
        loaded = this.removeBanners(zoneRes, loaded);
      }
    });
    return loaded;
  }
  removeBanners(sel,bnrs) {
    sel.map((v)=>{
      bnrs = bnrs.filter((t) => {return t.recId !== v.recId});
    });
    return bnrs;
  }
  processImpressions(pobj) {
    //console.log("Posting Impression",pobj);
    let headers = {
      "X-Alt-Referer": window.location.href,
      "Content-type": "application/json"
    };
    if(this.state.ApiAnonId) {
      headers["X-Alt-AnonymousId"] = this.state.ApiAnonId;
    }
    let dta = JSON.stringify(pobj)
    fetch(`${AppUrl}/creatives/impression`, {method: "POST", headers: headers, body: dta})
      .then(resp => resp.json())
      .then((data) => {
          //console.log("Response:",data);
        }
      ).catch((ex)=>{
      console.log("HTTP Error...",ex)
    });
  }
  postImpression(obj) {
    //try {
    if(obj.Zone.CountImpressions) {
      let {Impressions} = this.state;
      let pobj = {Requested: new Date(), Banner: {
          Click: {Guid: obj.Click.Guid},
          Creative: {Id: obj.Creative.Id, Campaign: {Id : obj.Creative.Campaign.Id}},
          Placement: {Id: obj.Placement.Id},
          Zone: {Id: obj.Zone.Id}
        }};
      Impressions.push(pobj);
    }
    //} catch(ex) {}
  }
  handleClick(e,cre) {

  }
  apiClick(id) {

  }
  load() {

  }
  render() {
    return null;
  }

  componentDidUpdate() {

  }


  //Utils Here
  isNullOrUndefined(val) {
    return val === null || typeof val === "undefined";
  }
  isNullOrEmpty(obj) {
    if(typeof obj === "undefined") { return true;}
    if(obj === null) { return true;}
    if(typeof obj === "string") { return obj === "" }
    return false;
  }
  isMoreThenZero(tInt) {
    if(this.isNullOrUndefined(tInt)) return false;
    if(typeof tInt === "string") {
      let cInt = parseInt(tInt,10);
      if(isNaN(cInt)) {
        return false;
      }
      return cInt > 0;
    } else {
      if(typeof tInt === "number") {
        return tInt > 0;
      }
    }
    return false;
  }
  MakeId(length) {
    let result = '';
    let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let charactersLength = characters.length;
    for ( let i = 0; i < length; i++ ) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }
}

export default BannersLoader;


